export var NavigateLocation;
(function (NavigateLocation) {
    /** Navigating within the app. */
    NavigateLocation[NavigateLocation["Internal"] = 0] = "Internal";
    /** Navigating to another site / closing the browser. */
    NavigateLocation[NavigateLocation["External"] = 1] = "External";
})(NavigateLocation || (NavigateLocation = {}));
